import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'
import { type DuplicateListSearchCriteria, DuplicateListSearchOptions } from 'Pages/DuplicateHandling/DuplicateListSearchOptions'
import { useState } from 'react'
import { type RowData } from 'Components/Table/DataTable/DataTable.model'
import { useGetAllDuplicatesQuery, useLazyLoadChildDuplicateQuery } from 'slices/duplicateChildSlice'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import * as AppRoutes from 'Pages/Routes'
import { DuplicateTable } from 'Components/DuplicateHandling/DuplicateTable'
import { useAuth } from 'hooks/use-auth'

export function DuplicateList (): JSX.Element {
  const nav = useNavigate()
  const { data: duplicateList, isLoading } = useGetAllDuplicatesQuery({ newOnly: false, unresolvedOnly: false })
  const [getDuplicateDetails] = useLazyLoadChildDuplicateQuery()
  const auth = useAuth()
  const showISD = (auth.user?.securityLevel ?? '') === 'MiECCAdmin'

  const [searchCriteria, setSearchCriteria] = useState<DuplicateListSearchCriteria>({
    childName: '',
    caregiverName: '',
    source: 'All',
    isResolved: 'N',
    isdID: null
  })

  const goHome = (): void => {
    nav('/')
  }

  const rowClick = async (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, row: RowData): Promise<void> => {
    const { data: childDupeRecord } = await getDuplicateDetails(row.duplicateID)
    if (childDupeRecord != null) {
      nav(AppRoutes.DUPE_MANAGEMENT)
    }
  }

  if (isLoading) return <CircularProgress />

  return <>
    <Typography variant='h3'>Duplicate List</Typography>
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
      <ArrowBackIcon onClick={goHome} sx={{ alignSelf: 'center', cursor: 'pointer', height: '16px', width: '16px' }} />
      <Breadcrumbs>
        <Link onClick={goHome} sx={{ fontSize: '14px', textTransform: 'none', color: 'inherit', textDecorationLine: 'none', cursor: 'pointer' }}>Home</Link>
      </Breadcrumbs>
    </Box>

    <DuplicateListSearchOptions
      current={searchCriteria}
      showISD={showISD}
      onChange={(newSearch) => { setSearchCriteria(newSearch) }}
    />

    <Box sx={{ width: '100%', padding: '30px 20px', borderRadius: '16px', background: '#fff' }}>
      <DuplicateTable
        name='duplicateList'
        duplicateList={duplicateList ?? []}
        searchCriteria={searchCriteria}
        showAllColumns={true}
        rowClick={rowClick}
        showISD={showISD}
      />
    </Box>
  </>
}
